import { cn } from '@/lib/utils'

interface TextAnimateLoadingProps {
  text: string
  className?: string
}

/** 文本动画渐变效果 */
export const TextAnimateGradient = ({ text, className }: TextAnimateLoadingProps) => {
  return (
    <p className={cn(
      "text-sm font-medium",
      "bg-[linear-gradient(91deg,rgba(16,24,40,0.4)_30%,rgba(16,24,40,1)_50%,rgba(16,24,40,0.4)_70%)]",
      "bg-[length:200%_100%]",
      "bg-clip-text text-transparent",
      "animate-text-loading",
      className
    )}>
      {text}
    </p>
  )
}
